import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { PetlService } from '../../../services/petl.service';
import { PetlBaseComponent } from '../petl-base.component';
var PetlAboutComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PetlAboutComponent, _super);
    function PetlAboutComponent(_vcr, petlService, cdr) {
        var _this = _super.call(this, _vcr, petlService, cdr) || this;
        _this.petlService = petlService;
        _this.cdr = cdr;
        return _this;
    }
    PetlAboutComponent.prototype.toggleAbout = function () {
        this.toggleView('about');
    };
    return PetlAboutComponent;
}(PetlBaseComponent));
export { PetlAboutComponent };
